/* Custom dropdowns that match the glass style. The real <select> stays in the page (hidden), so forms,
   autofill and other scripts keep working. Without JS, the normal browser dropdown is used. */
(function () {
  'use strict';
  var doc = document;
  var uid = 0;

  function build(sel) {
    if (sel.__cs || sel.multiple || sel.size > 1) return;
    sel.__cs = true;
    var id = 'cs' + (++uid);
    var wrap = doc.createElement('div');
    wrap.className = 'cs';
    sel.parentNode.insertBefore(wrap, sel);
    wrap.appendChild(sel);
    sel.classList.add('cs-native');
    sel.tabIndex = -1;
    sel.setAttribute('aria-hidden', 'true');

    var btn = doc.createElement('button');
    btn.type = 'button';
    btn.className = 'cs-btn';
    btn.setAttribute('aria-haspopup', 'listbox');
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', id);
    var lab = sel.id ? doc.querySelector('label[for="' + sel.id + '"]') : null;
    if (lab) { if (!lab.id) lab.id = id + '-l'; btn.setAttribute('aria-labelledby', lab.id); }
    wrap.appendChild(btn);

    var list = doc.createElement('ul');
    list.className = 'cs-list';
    list.id = id;
    list.setAttribute('role', 'listbox');
    list.tabIndex = -1;
    wrap.appendChild(list);

    var items = [];
    [].slice.call(sel.options).forEach(function (o, i) {
      var li = doc.createElement('li');
      li.setAttribute('role', 'option');
      li.textContent = o.text;
      li.dataset.i = i;
      if (o.disabled) li.setAttribute('aria-disabled', 'true');
      if (o.value === '') li.classList.add('cs-empty');
      list.appendChild(li);
      items.push(li);
    });

    var active = -1;
    function paint() {
      var cur = sel.options[sel.selectedIndex];
      btn.textContent = cur ? cur.text : '';
      btn.classList.toggle('placeholder', !!cur && cur.value === '');
      items.forEach(function (li, i) { li.setAttribute('aria-selected', i === sel.selectedIndex ? 'true' : 'false'); });
    }
    function setActive(i, scroll) {
      active = i;
      items.forEach(function (li, k) { li.classList.toggle('active', k === i); });
      if (scroll && items[i]) items[i].scrollIntoView({ block: 'nearest' });
      if (items[i]) btn.setAttribute('aria-activedescendant', id + '-o' + i);
    }
    items.forEach(function (li, i) { li.id = id + '-o' + i; });

    function open() {
      if (wrap.classList.contains('open')) return;
      doc.dispatchEvent(new CustomEvent('cs-close-others', { detail: wrap }));
      wrap.classList.add('open');
      btn.setAttribute('aria-expanded', 'true');
      var r = btn.getBoundingClientRect();
      var below = window.innerHeight - r.bottom, need = Math.min(300, window.innerHeight * 0.45) + 12;
      wrap.classList.toggle('up', below < need && r.top > below);
      setActive(sel.selectedIndex, true);
    }
    function close(focus) {
      wrap.classList.remove('open');
      btn.setAttribute('aria-expanded', 'false');
      btn.removeAttribute('aria-activedescendant');
      if (focus) btn.focus();
    }
    function choose(i) {
      var o = sel.options[i];
      if (!o || o.disabled) return;
      sel.selectedIndex = i;
      sel.dispatchEvent(new Event('input', { bubbles: true }));
      sel.dispatchEvent(new Event('change', { bubbles: true }));
      paint(); close(true);
    }
    function move(d) {
      var i = active;
      do { i += d; } while (items[i] && items[i].getAttribute('aria-disabled') === 'true');
      if (i >= 0 && i < items.length) setActive(i, true);
    }

    btn.addEventListener('click', function () { wrap.classList.contains('open') ? close(false) : open(); });
    list.addEventListener('mousedown', function (e) { e.preventDefault(); });
    list.addEventListener('click', function (e) { var li = e.target.closest('li'); if (li) choose(parseInt(li.dataset.i, 10)); });
    list.addEventListener('mousemove', function (e) { var li = e.target.closest('li'); if (li) setActive(parseInt(li.dataset.i, 10), false); });

    var buf = '', bufT;
    btn.addEventListener('keydown', function (e) {
      var isOpen = wrap.classList.contains('open');
      if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
        e.preventDefault();
        if (!isOpen) open(); else move(e.key === 'ArrowDown' ? 1 : -1);
      } else if (e.key === 'Home' && isOpen) { e.preventDefault(); setActive(0, true); }
      else if (e.key === 'End' && isOpen) { e.preventDefault(); setActive(items.length - 1, true); }
      else if (e.key === 'Enter' || e.key === ' ') {
        if (isOpen) { e.preventDefault(); choose(active); }
        else if (e.key === ' ') { e.preventDefault(); open(); }
      } else if (e.key === 'Escape' && isOpen) { e.preventDefault(); close(true); }
      else if (e.key === 'Tab' && isOpen) { close(false); }
      else if (e.key.length === 1 && !e.ctrlKey && !e.metaKey) {
        buf += e.key.toLowerCase(); clearTimeout(bufT); bufT = setTimeout(function () { buf = ''; }, 600);
        var start = Math.max(0, active);
        for (var k = 0; k < items.length; k++) {
          var idx = (start + (buf.length === 1 ? 1 : 0) + k) % items.length;
          if (items[idx].textContent.toLowerCase().indexOf(buf) === 0 && !items[idx].classList.contains('cs-empty')) {
            if (!isOpen) open();
            setActive(idx, true); break;
          }
        }
      }
    });
    doc.addEventListener('click', function (e) { if (!wrap.contains(e.target)) close(false); });
    doc.addEventListener('cs-close-others', function (e) { if (e.detail !== wrap) close(false); });
    sel.addEventListener('change', paint);
    var form = sel.form;
    if (form) form.addEventListener('reset', function () { setTimeout(paint, 0); });
    paint();
  }

  [].slice.call(doc.querySelectorAll('select')).forEach(build);
})();
